import InfrastructureRoutes from "./InfrastructureRoutes";

export default InfrastructureRoutes;
